export default "__VITE_ASSET__CJhGNWf5__"